export default __webpack_public_path__ + "static/media/switch.f8dccc97.svg";